/**
 * The message to show when setting a new password fails. The API puts it under
 * `confirm_password` (or `detail` for rate limits); otherwise use the fallback.
 */
export function getConfirmPasswordError(error, fallback) {
  const data = error?.response?.data;
  const message = data?.confirm_password ?? data?.detail;
  if (Array.isArray(message)) {
    return message.join(" ");
  }
  return message || fallback;
}
